<!--会议我提交的查询组件-->
<template>
  <div class="cardtable">
    <v-flex xs12>
      <div class="event-filter">
        <v-flex xs12>
          <v-layout row>
            <v-flex xs10>
              <div class="event-title">
                {{ this.$t('masterData.filter') }}
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-layout row>
          <v-flex xs12 md3>
            <div class="event-filter-title">
              {{ this.$t('masterData.supplycode') }}
            </div>
          </v-flex>
          <v-flex xs12 md3>
            <div class="event-filter-title">
              {{ this.$t('masterData.supplyname') }}
            </div>
          </v-flex>
          <v-flex xs12 md3>
            <div class="event-filter-title">
              {{ this.$t('masterData.materialname') }}
            </div>
          </v-flex>
          <v-flex xs12 md3>
            <div class="event-filter-title">
              {{ this.$t('masterData.status') }}
            </div>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs3>
            <v-text-field
              required
              class="filter-interval event-filter-content"
              v-model="filter.vendorCode"
              :value="filter.vendorCode"
            ></v-text-field>
          </v-flex>
          <v-flex xs3>
            <v-text-field
              required
              class="filter-interval event-filter-content"
              v-model="filter.vendorName"
              :value="filter.vendorName"
            ></v-text-field>
          </v-flex>
          <v-flex xs3>
            <v-text-field
              required
              class="filter-interval event-filter-content"
              v-model="filter.materialName"
              :value="filter.materialName"
            ></v-text-field>
          </v-flex>
          <v-flex xs3>
            <v-select
              v-model="filter.status"
              :items="statusitems"
              class="filter-interval event-filter-content"
              item-text="text"
              item-value="value"
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs2>
            <v-btn
              @click="clearfilter()"
              color="#1cade4"
              class="Btn_add"
              depressed
              >{{ this.$t('masterData.clearfilter') }}</v-btn
            >
          </v-flex>
          <v-flex xs2 v-if="ismodify">
            <v-btn @click="add()" color="#1cade4" class="Btn_add" depressed>{{
              this.$t('masterData.add')
            }}</v-btn>
          </v-flex>
          <v-flex xs2>
            <v-btn
              depressed
              color="#1cade4"
              class="Btn_add"
              @click="getdatas()"
              >{{ this.$t('masterData.apply') }}</v-btn
            >
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs8> </v-flex>
        </v-layout>
      </div>
    </v-flex>
    <v-flex xs12 style="background-color:white!important;">
      <div class="allevent-content">
        <div class="table-header">
          <v-layout row>
            <v-flex xs12 md1>
              <span>物料号</span>
            </v-flex>
            <v-flex xs12 md2>
              <span>物料名称</span>
            </v-flex>
            <v-flex xs12 md1>
              <div>供应商</div>
              <div>代码</div>
            </v-flex>
            <v-flex xs12 md2>
              <div>供应商</div>
              <div>名称</div>
            </v-flex>
            <v-flex xs12 md2>
              <span>生产厂家</span>
            </v-flex>
            <v-flex xs12 md2>
              <span>生产地址</span>
            </v-flex>
            <v-flex xs12 md1>
              <span>有效期</span>
            </v-flex>
            <v-flex xs12 md1>
              <div>到货剩余</div>
              <div>有效期</div>
            </v-flex>
            <v-flex xs12 md1>
              <span>模式</span>
            </v-flex>
            <v-flex xs12 md1>
              <span>{{ this.$t('masterData.status') }}</span>
            </v-flex>
            <v-flex xs12 md1>
              <span>数据状态</span>
            </v-flex>
            <v-flex xs12 md2> </v-flex>
          </v-layout>
        </div>
        <div class="table-row" v-for="(item, key) in data.items" :key="key">
          <v-layout row>
            <v-flex xs12 md1>
              <div class=" table-cell ">
                {{ item.materialCode }}
              </div>
            </v-flex>
            <v-flex xs12 md2>
              <div class=" table-cell ">
                {{ item.materialName }}
              </div>
            </v-flex>
            <v-flex xs12 md1>
              <div class=" table-cell ">
                {{ item.vendorCode }}
              </div>
            </v-flex>
            <v-flex xs12 md2>
              <div class=" table-cell ">
                {{ item.vendorName }}
              </div>
            </v-flex>
            <v-flex xs12 md2>
              <div class=" table-cell ">
                {{ item.manufacturerName }}
              </div>
            </v-flex>
            <v-flex xs12 md2>
              <div class=" table-cell ">
                {{ item.manufacturerAddress }}
              </div>
            </v-flex>
            <v-flex xs12 md1>
              <div class=" table-cell ">
                {{ item.validMonth }}
              </div>
            </v-flex>
            <v-flex xs12 md1>
              <div class=" table-cell ">
                {{ item.remainingMonth }}
              </div>
            </v-flex>
            <v-flex xs12 md1>
              <div class=" table-cell ">
                {{ item.isByMonth === true ? '按月' : '按天' }}
              </div>
            </v-flex>
            <v-flex xs12 md1>
              <div class=" table-cell " v-if="item.isDraft === false">
                {{ item.isEnabled === true ? '有效' : '失效' }}
              </div>
            </v-flex>
            <v-flex xs12 md1>
              <div class=" table-cell ">
                {{ item.isDraft === true ? '草稿' : '正式' }}
              </div>
            </v-flex>
            <v-flex xs12 md2>
              <v-layout row>
                <v-flex xs12 md4 v-if="item.isDraft && ismodify">
                  <div @click="editData(key)" class=" table-cell  event-no">
                    编辑
                  </div>
                </v-flex>
                <v-flex
                  xs12
                  md4
                  v-if="!item.isEnabled && !item.isDraft && isconfirm"
                >
                  <div @click="masterEnable(key)" class=" table-cell  event-no">
                    启用
                  </div>
                </v-flex>
                <v-flex
                  xs12
                  md4
                  v-if="item.isEnabled && !item.isDraft && isconfirm"
                >
                  <div
                    @click="masterDisable(key)"
                    class=" table-cell  event-no"
                  >
                    禁用
                  </div>
                </v-flex>
                <v-flex
                  xs12
                  md4
                  v-if="item.isEnabled && !item.isDraft && isconfirm"
                >
                  <div @click="masterReturn(key)" class=" table-cell  event-no">
                    反确认
                  </div>
                </v-flex>
                <v-flex xs12 md4 v-if="item.isDraft && isconfirm">
                  <div
                    @click="masterConfirm(key)"
                    class=" table-cell  event-no"
                  >
                    确认
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
        <div v-if="data.items.length == 0" class="partipant-module-MESSAGE">
          {{ this.$t('emptymsg') }}
        </div>
        <v-pagination
          v-if="length > 0"
          v-model="page"
          :length="length"
          :total-visible="10"
        ></v-pagination>
      </div>
    </v-flex>
    <v-dialog v-model="dialog" width="400">
      <v-form ref="form" lazy-validation>
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            <v-flex xs12>
              <v-layout row>
                <v-flex xs3> {{ this.$t('common.edit') }}</v-flex>
                <v-flex xs8></v-flex>
                <v-flex xs1>
                  <v-icon @click="dialogclose()">mdi-close</v-icon>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-card-title>
          <v-flex xs12>
            <v-layout row class="editcontent">
              <v-flex xs12>
                <v-text-field
                  required
                  v-model="data.info.vendorCode"
                  style="padding-right:30px;padding-left:10px;padding-top: 0px;"
                  label="供应商编码"
                  :rules="nameRules"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row class="editcontent">
              <v-flex xs12>
                <v-text-field
                  required
                  v-model="data.info.vendorName"
                  label="供应商名称"
                  :rules="nameRules"
                  style="padding-right:30px;padding-left:10px;padding-top: 0px;"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row class="editcontent">
              <v-flex xs12>
                <v-text-field
                  required
                  v-model="data.info.materialCode"
                  label="物料号"
                  :rules="nameRules"
                  style="padding-right:30px;padding-left:10px;padding-top: 0px;"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row class="editcontent">
              <v-flex xs12>
                <v-text-field
                  required
                  v-model="data.info.materialName"
                  label="物料名称"
                  :rules="nameRules"
                  style="padding-right:30px;padding-left:10px;padding-top: 0px;"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row class="editcontent">
              <v-flex xs12>
                <v-text-field
                  v-model="data.info.manufacturerName"
                  label="生产厂家"
                  style="padding-right:30px;padding-left:10px;padding-top: 0px;"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row class="editcontent">
              <v-flex xs12>
                <v-text-field
                  required
                  v-model="data.info.manufacturerAddress"
                  label="生产地址"
                  :rules="nameRules"
                  style="padding-right:30px;padding-left:10px;padding-top: 0px;"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row class="editcontent">
              <v-flex xs12>
                <v-text-field
                  required
                  v-model="data.info.validMonth"
                  label="有效期"
                  :rules="numberrules"
                  style="padding-right:30px;padding-left:10px;padding-top: 0px;"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row class="editcontent">
              <v-flex xs12>
                <v-text-field
                  required
                  v-model="data.info.remainingMonth"
                  label="到货剩余有效期"
                  :rules="numberrules"
                  style="padding-right:30px;padding-left:10px;padding-top: 0px;"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row class="effective">
              <v-flex xs12>
                <v-layout row>
                  <v-flex xs6>
                    <v-switch
                      v-model="data.info.isByMonth"
                      min="-100"
                      max="100"
                      label="按月计算"
                    ></v-switch>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row class="effective">
              <v-flex xs12>
                <v-btn
                  depressed
                  color="#1cade4"
                  class="Btn_add"
                  @click="SaveData()"
                  >{{ this.$t('common.save') }}</v-btn
                >
              </v-flex>
            </v-layout>
          </v-flex>
          <v-divider></v-divider>
        </v-card>
      </v-form>
    </v-dialog>
    <core-dataloading ref="dataload"></core-dataloading>
    <core-confirm ref="myConfirm" @userBehavior="userBehavior"></core-confirm>
  </div>
</template>
<style>
.editcontent {
  margin-top: 10px;
  margin-left: 60px;
  margin-right: 60px;
}
.effective {
  margin-left: 70px;
  margin-right: 60px;
}
.table-row > div {
  text-align: left;
}
</style>
<script>
import { mapState } from 'vuex'
import { PowerJudge } from '@/common/common'
import CoreDataloading from '@/components/core/dataloading.vue'
import CoreConfirm from '@/components/core/confirm.vue'
import {
  masterList,
  mastercreate,
  masterUpdate,
  masterConfirm,
  masterReturn,
  masterEnable,
  masterDisable
} from '@/request/api'
export default {
  components: {
    CoreDataloading,
    CoreConfirm
  },
  data: () => ({
    search: '',
    filter: {
      vendorCode: '',
      vendorName: '',
      materialName: '',
      status: null
    },
    statusitems: [
      { text: '全部', value: null },
      { text: '有效', value: true },
      { text: '无效', value: false }
    ],
    length: 0,
    page: 1,
    pagesize: 8,
    menu1: false,
    menu2: false,
    dialog: false,
    Effective: true,
    actionType: 1
  }),
  mounted: function() {
    this.$nextTick(() => {
      this.getdatas()
    })
    this.base.confirmDialog = this.$refs.myConfirm
  },
  computed: {
    ...mapState({
      data: state => state.data,
      base: state => state.base
    }),
    draft() {
      return this.$t('masterData.draft')
    },
    edit() {
      return this.$t('common.edit')
    },
    comfirm() {
      return this.$t('masterData.confirm')
    },
    isconfirm() {
      return PowerJudge('master-confirm')
    },
    ismodify() {
      return PowerJudge('master-modify')
    },
    numberrules() {
      return [v => /^\d{1,3}(,?\d{3})*(\.\d{1,2})?$/.test(v) || '值必须为数字']
    },
    //不为空校验规则
    nameRules() {
      return [v => !!v || '不能为空']
    }
  },
  watch: {
    page() {
      this.getdatas()
    },
    pagesize() {
      this.getdatas()
    }
  },
  methods: {
    add() {
      this.actionType = 1
      var param = {
        materialCode: null,
        materialName: null,
        vendorCode: null,
        vendorName: null,
        manufacturerName: null,
        manufacturerAddress: null,
        validMonth: 0,
        remainingMonth: 0,
        isByMonth: true,
        isEnabled: true
      }
      this.data.info = param
      this.dialog = true
    },
    dialogclose() {
      this.dialog = false
    },
    getdatas() {
      var _this = this
      let param = {
        vendorCode: _this.filter.vendorCode,
        vendorName: _this.filter.vendorName,
        materialName: _this.filter.materialName,
        status: _this.filter.status,
        t: new Date().getTime()
      }
      this.base.eventdom
        .CommonEventApi(
          masterList,
          param,
          this.$refs.dataload,
          this.$refs.myConfirm,
          '正在查询数据'
        )
        .then(res => {
          _this.data.items = res
        })
    },
    clearfilter() {
      this.filter = {
        vendorCode: '',
        vendorName: '',
        materialName: '',
        status: null
      }
    },
    SaveData() {
      if (this.$refs.form.validate()) {
        var _this = this
        var info = {
          id: _this.data.info.id,
          materialCode: _this.data.info.materialCode,
          materialName: _this.data.info.materialName,
          vendorCode: _this.data.info.vendorCode,
          vendorName: _this.data.info.vendorName,
          manufacturerName: _this.data.info.manufacturerName,
          manufacturerAddress: _this.data.info.manufacturerAddress,
          validMonth: parseInt(_this.data.info.validMonth),
          remainingMonth: parseInt(_this.data.info.remainingMonth),
          isByMonth: _this.data.info.isByMonth
          //isEnabled: _this.data.info.isEnabled
        }
        var param = info
        if (this.actionType == 1) {
          this.base.eventdom
            .CommonEventApi(
              mastercreate,
              param,
              this.$refs.dataload,
              this.$refs.myConfirm,
              '正在保存数据'
            )
            .then(() => {
              _this.$refs.myConfirm.show('保存成功', {
                type: 'alert',
                data: 'success'
              })
            })
        } else {
          this.base.eventdom
            .CommonEventApi(
              masterUpdate,
              param,
              this.$refs.dataload,
              this.$refs.myConfirm,
              '正在保存数据'
            )
            .then(() => {
              _this.dialog = false
              _this.$refs.myConfirm.show('保存成功', {
                type: 'alert',
                data: 'success'
              })
            })
        }
      }
    },
    masterConfirm(key) {
      var item = this.data.items[key]
      this.base.eventdom
        .CommonEventApi(
          masterConfirm,
          item.id,
          this.$refs.dataload,
          this.$refs.myConfirm,
          '正在确认数据'
        )
        .then(() => {
          this.$refs.myConfirm.show('保存成功', {
            type: 'alert',
            data: 'success'
          })
        })
    },
    masterReturn(key) {
      var item = this.data.items[key]
      this.base.eventdom
        .CommonEventApi(
          masterReturn,
          item.id,
          this.$refs.dataload,
          this.$refs.myConfirm,
          '正在撤销数据'
        )
        .then(() => {
          this.$refs.myConfirm.show('保存成功', {
            type: 'alert',
            data: 'success'
          })
        })
    },
    userBehavior(outerData) {
      if (outerData == 'success') {
        this.dialog = false
        this.getdatas()
      }
    },
    editData(key) {
      this.actionType = 2
      var item = this.data.items[key]
      var param = {
        id: item.id,
        materialCode: item.materialCode,
        materialName: item.materialName,
        vendorCode: item.vendorCode,
        vendorName: item.vendorName,
        manufacturerName: item.manufacturerName,
        manufacturerAddress: item.manufacturerAddress,
        validMonth: item.validMonth,
        remainingMonth: item.remainingMonth,
        isByMonth: item.isByMonth,
        isEnabled: item.isEnabled
      }
      this.data.info = param
      this.dialog = true
    },
    masterEnable(key) {
      var item = this.data.items[key]
      this.base.eventdom
        .CommonEventApi(
          masterEnable,
          item.id,
          this.$refs.dataload,
          this.$refs.myConfirm,
          '正在启用数据'
        )
        .then(() => {
          this.$refs.myConfirm.show('启用成功', {
            type: 'alert',
            data: 'success'
          })
        })
    },
    masterDisable(key) {
      var item = this.data.items[key]
      this.base.eventdom
        .CommonEventApi(
          masterDisable,
          item.id,
          this.$refs.dataload,
          this.$refs.myConfirm,
          '正在禁用数据'
        )
        .then(() => {
          this.$refs.myConfirm.show('禁用成功', {
            type: 'alert',
            data: 'success'
          })
        })
    }
  }
}
</script>
